import React, { useContext } from "react";
import { Helmet } from "react-helmet-async";
import { LanguageContext } from "../locales/LanguageContext";
import unauthorizedTranslations from "../locales/unauthorizedTranslations";

const Unauthorized = () => {
  const { lang } = useContext(LanguageContext);
  const t = unauthorizedTranslations[lang] || {};

  return (
    <div className="container py-5 text-center">
      <Helmet>
        <title>AKAAL KIDS | {t.pageTitle || "Unauthorized"}</title>
      </Helmet>
      <div
        style={{
          width: "100%",
          background: "linear-gradient(90deg, #f6815e 0%, #f6b93b 100%)",
          color: "#fff",
          padding: "38px 0 24px 0",
          textAlign: "center",
          marginBottom: 32,
          boxShadow: "0 4px 24px #f6815e22",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <h1
          style={{
            fontWeight: 900,
            fontSize: "2.6rem",
            letterSpacing: 1,
            marginBottom: 11,
            textShadow: "0 2px 12px #f6815e55",
          }}
        >
          {t.pageTitle || "Unauthorized"}
        </h1>
      </div>
      <div
        className="card border-0 shadow-lg p-5 mx-auto"
        style={{ maxWidth: 480, borderRadius: 18 }}
      >
        <h2 style={{ color: "#f6815e", fontWeight: 700, marginBottom: 24 }}>
          {t.heading || "Access Denied"}
        </h2>
        <p style={{ color: "#444", fontSize: "1.15rem", marginBottom: 32 }}>
          {t.message || "You do not have permission to view this page."}
        </p>
        <a
          href="/"
          className="btn btn-primary px-4"
          style={{ fontWeight: 700, fontSize: "1.1rem" }}
        >
          {t.homeBtn || "Go to Home"}
        </a>
      </div>
    </div>
  );
};

export default Unauthorized;
